module.exports = __webpack_public_path__ + "img/avatar.869471ff.png";